class MapHours extends HTMLElement {
    constructor() {
      super();
      this.mapElement = this.querySelector('.map-hours__map-element');
      this.apiKey = this.querySelector('.map-hours__google-map')?.dataset.apiKey;
      this.address = this.querySelector('.map-hours__google-map')?.dataset.address;
      
      if ( this.apiKey && this.address) {   
        this.loadGoogleMaps();
      }
      
      // Add event listener for content loaded to sync heights
      window.addEventListener('DOMContentLoaded', () => this.syncHeights());
      window.addEventListener('resize', () => this.syncHeights());
      
      // Run once on init
      this.syncHeights();
    }
    
    syncHeights() {
      const infoElement = this.querySelector('.map-hours__info');
      const mapElement = this.querySelector('.map-hours__map');
      
      if (window.innerWidth > 768) {
        // Reset heights to calculate properly
        infoElement.style.height = 'auto';
        mapElement.style.height = 'auto';
        
        // Get heights
        const infoHeight = infoElement.offsetHeight;
        const mapHeight = mapElement.offsetHeight;
        
        // Set both to the larger height
        const maxHeight = Math.max(infoHeight, mapHeight);
        infoElement.style.height = `${maxHeight}px`;
        mapElement.style.height = `${maxHeight}px`;
      } else {
        // On mobile, reset heights to auto
        infoElement.style.height = 'auto';
        mapElement.style.height = 'auto';
      }
    }
  
    loadGoogleMaps() {
      if (window.google?.maps) {
        this.initMap();
      } else {
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}`;
        script.onload = () => this.initMap();
        document.head.appendChild(script);
      }
    }
  
    async initMap() {
      const geocoder = new google.maps.Geocoder();
      try {
        const result = await this.geocodeAddress(geocoder, this.address);
        const map = new google.maps.Map(this.mapElement, {
          center: result.geometry.location,
          zoom: 15,
          styles: this.getMapStyles()
        });
        
        new google.maps.Marker({
          map,
          position: result.geometry.location
        });
        
        // Sync heights after map loads
        google.maps.event.addListenerOnce(map, 'idle', () => {
          setTimeout(() => this.syncHeights(), 300);
        });
      } catch (error) {
        console.error('Error loading map:', error);
      }
    }
  
    geocodeAddress(geocoder, address) {
      return new Promise((resolve, reject) => {
        geocoder.geocode({ address }, (results, status) => {
          if (status === 'OK') {
            resolve(results[0]);
          } else {
            reject(status);
          }
        });
      });
    }
  
    getMapStyles() {
      try {
        const stylesScript = document.getElementById('map-styles');
        if (stylesScript) {
          return JSON.parse(stylesScript.textContent).styles;
        }
      } catch (e) {
        console.error('Error parsing map styles:', e);
      }
      return [];
    }
  }
  
  customElements.define('map-hours-section', MapHours);